import * as React from 'react'

const WantToLeaveIcon = props => (
  <svg
    width="126"
    height="127"
    viewBox="0 0 126 127"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M78.8357 39.2953V34.397C78.8357 23.7133 70.1732 15.0508 59.4894 15.0508H33.8957C23.2172 15.0508 14.5547 23.7133 14.5547 34.397V92.8295C14.5547 103.513 23.2172 112.176 33.8957 112.176H59.5419C70.1942 112.176 78.8357 103.54 78.8357 92.8873V87.9365"
      stroke="#D72B4F"
      stroke-width="6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M114.5 63.6133H51.2852"
      stroke="#D72B4F"
      stroke-width="6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M99.1289 48.3086L114.501 63.6123L99.1289 78.9213"
      stroke="#D72B4F"
      stroke-width="6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export default WantToLeaveIcon
